// extracted by mini-css-extract-plugin
export var bottomContainer = "roles-bar-module--bottomContainer--7bab3";
export var box = "roles-bar-module--box--bb91f";
export var customer = "roles-bar-module--customer--46f86";
export var employee = "roles-bar-module--employee--19fdf";
export var last = "roles-bar-module--last--24d38";
export var rolesBoxContainer = "roles-bar-module--rolesBoxContainer--1dafe";
export var rolesContainer = "roles-bar-module--rolesContainer--9ac8c";
export var select = "roles-bar-module--select--5d81f";
export var selected = "roles-bar-module--selected--f64ae";
export var simple = "roles-bar-module--simple--2558a";
export var topContainer = "roles-bar-module--topContainer--cdd9f";